import { useEffect } from 'react';

const useOutsideClick = (ref, callback, useDependency = false, additionalDetector) => {
  useEffect(
    () => {
      const handleClick = event => {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          (!additionalDetector || additionalDetector(event))
        ) {
          callback(event);
        }
      };

      document.addEventListener('click', handleClick, true);

      return () => {
        document.removeEventListener('click', handleClick, true);
      };
    },
    useDependency ? [callback] : []
  );
};

export default useOutsideClick;
